/* tslint:disable:rule1 max-line-length */

import * as React from 'react';

export const AddIcon = ({ onClick }) => {
  return (
    <svg role='button' onClick={onClick} width='22' height='22' xmlns='http://www.w3.org/2000/svg'>
      <g>
        <title>background</title>
        <rect fill='none' id='canvas_background' height='24' width='24' y='-1' x='-1' />
        <g display='none' overflow='visible' y='0' x='0' height='100%' width='100%' id='canvasGrid'>
          <rect fill='url(#gridpattern)' strokeWidth='0' y='0' x='0' height='100%' width='100%' />
        </g>
      </g>
      <g>
        <title>Layer 1</title>
        <line id='svg_2' y2='11' x2='22' y1='11' x1='0' strokeWidth='2' stroke='#31358f' fill='none' />
        <line id='svg_5' y2='21.924803' x2='11' y1='0.075197' x1='11' strokeWidth='2' stroke='#31358f' fill='none' />
      </g>
    </svg>
  );
};
